/**
 * Infinite Options Add-on Price Updater
 *
 * Updates the displayed product price on the product page in real-time
 * when a customer selects a delivery/installation add-on option from
 * the Infinite Options (Customizery) app.
 *
 * Works with both radio buttons (install-option) and checkboxes (install-only).
 * Updates both the main product price and the sticky add-to-cart bar price.
 */
(function () {
  'use strict';

  var POLL_INTERVAL = 500;
  var MAX_POLLS = 20;
  var pollCount = 0;

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parsePriceCents(text) {
    if (!text) return 0;
    var cleaned = text.replace(/[^0-9.]/g, '');
    return Math.round(parseFloat(cleaned) * 100) || 0;
  }

  function getAddonPrice() {
    var io = window.Shoppad && window.Shoppad.apps && window.Shoppad.apps.infiniteoptions;
    if (!io || !io.priceMod || !io.priceMod.activeVariants) return 0;
    var total = 0;
    var variants = io.priceMod.activeVariants;
    for (var key in variants) {
      if (variants.hasOwnProperty(key)) {
        var v = variants[key];
        if (v && v.price) {
          total += Math.round(parseFloat(v.price) * 100);
        }
      }
    }
    return total;
  }

  function getBasePrice() {
    var mainSection = document.querySelector('[id^="shopify-section-template"] product-price');
    if (!mainSection) return null;
    if (!mainSection._basePriceCents) {
      var priceEl = mainSection.querySelector('.price');
      if (priceEl) {
        mainSection._basePriceCents = parsePriceCents(priceEl.textContent);
      }
    }
    return mainSection._basePriceCents || null;
  }

  function getBaseComparePrice() {
    var mainSection = document.querySelector('[id^="shopify-section-template"] product-price');
    if (!mainSection) return null;
    if (!mainSection._baseCompareCents) {
      var compareEl = mainSection.querySelector('.compare-at-price');
      if (compareEl) {
        mainSection._baseCompareCents = parsePriceCents(compareEl.textContent);
      }
    }
    return mainSection._baseCompareCents || null;
  }

  function updatePriceDisplay() {
    var baseCents = getBasePrice();
    if (!baseCents) return;

    var addonCents = getAddonPrice();
    var newTotal = baseCents + addonCents;
    var newTotalFormatted = formatMoney(newTotal);

    // Update main product price
    var mainProductPrice = document.querySelector('[id^="shopify-section-template"] product-price');
    if (mainProductPrice) {
      var priceEl = mainProductPrice.querySelector('.price');
      if (priceEl) {
        priceEl.textContent = newTotalFormatted;
      }

      // Update compare-at price too if it exists
      var baseCompare = getBaseComparePrice();
      if (baseCompare) {
        var compareEl = mainProductPrice.querySelector('.compare-at-price');
        if (compareEl) {
          compareEl.textContent = formatMoney(baseCompare + addonCents);
        }
      }
    }

    // Update sticky add-to-cart bar price
    var stickyBar = document.querySelector('.sticky-add-to-cart');
    if (stickyBar) {
      var stickyPrice = stickyBar.querySelector('.price');
      if (stickyPrice) {
        stickyPrice.textContent = newTotalFormatted;
      }
      var stickyCompare = stickyBar.querySelector('.compare-at-price');
      if (stickyCompare && getBaseComparePrice()) {
        stickyCompare.textContent = formatMoney(getBaseComparePrice() + addonCents);
      }
    }
  }

  function resetBasePrice() {
    var mainSection = document.querySelector('[id^="shopify-section-template"] product-price');
    if (mainSection) {
      delete mainSection._basePriceCents;
      delete mainSection._baseCompareCents;
    }
  }

  function attachListeners() {
    var container = document.getElementById('infiniteoptions-container');
    if (!container) {
      pollCount++;
      if (pollCount < MAX_POLLS) {
        setTimeout(attachListeners, POLL_INTERVAL);
      }
      return;
    }

    // Store base price before any add-on is applied
    getBasePrice();
    getBaseComparePrice();

    // Listen for radio button and checkbox changes
    container.addEventListener('change', function () {
      // Small delay to let Infinite Options update its priceMod
      setTimeout(updatePriceDisplay, 100);
    });

    // Also listen for click events (some radio buttons fire click but not change)
    container.addEventListener('click', function (e) {
      if (e.target.tagName === 'INPUT') {
        setTimeout(updatePriceDisplay, 150);
      }
    });

    // Listen for variant changes (when user picks a different size/material)
    // This resets the base price since the variant price changed
    var section = document.querySelector('[id^="shopify-section-template"]');
    if (section) {
      section.addEventListener('variant:change', function () {
        resetBasePrice();
        setTimeout(function () {
          getBasePrice();
          getBaseComparePrice();
          updatePriceDisplay();
        }, 300);
      });
    }

    // Also observe for Infinite Options DOM changes (app may re-render)
    var observer = new MutationObserver(function (mutations) {
      var hasNewInputs = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewInputs) {
        setTimeout(updatePriceDisplay, 200);
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  // Also re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function () {
    pollCount = 0;
    attachListeners();
  });
})();
